import { CustomCellRendererProps } from 'ag-grid-react';
import { TrendingDown, TrendingUp } from 'lucide-react';

/**
 * Trend矢印を表示するカスタムセルレンダラー
 * @param params
 * @returns
 */
export const CellRendererTrend = (params: CustomCellRendererProps) => {
    // 値がプラスの場合
    if (params.value > 0) {
        return (
            <span style={{ color: 'red', display: 'flex', alignItems: 'center', gap: '4px' }}>
                <TrendingUp size={16} /> +{params.value.toLocaleString()}
            </span>
        );
    }
    // 値がマイナスの場合
    else if (params.value < 0) {
        return (
            <span style={{ color: 'blue', display: 'flex', alignItems: 'center', gap: '4px' }}>
                <TrendingDown size={16} /> {params.value.toLocaleString()}
            </span>
        );
    }
    // 値が0の場合
    else {
        return <span style={{ color: 'black', display: 'flex', alignItems: 'center', gap: '4px' }}>{params.value}</span>;
    }
};
